import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import DefaultButton from "../../../../../components/Buttons/Default";
import { post } from "../../../../../utils/helpers/api";
import { toast } from "react-toastify";

function CreateJobPositionModal({ isOpen, toggle, refreshSettings, jobPositionToEdit }) {
  const { t } = useTranslation();
  const [saveLoading, setSaveLoading] = useState(false);
  const [sourceData, setSourceData] = useState({
    name: jobPositionToEdit?.name || null,
  });

  useEffect(() => {
    if(jobPositionToEdit) {
      setSourceData({
        name: jobPositionToEdit?.name || null,
      });
    } else {
      setSourceData({
        name: null,
      });
    }
  }, [jobPositionToEdit, isOpen]);

  const saveJobPosition = async () => {
    setSaveLoading(true);
    const url = jobPositionToEdit ? `/hr/positions/update/${jobPositionToEdit.id}` : '/hr/positions/store';
    const data = await post(url, sourceData)
    if(data?.success) {
      refreshSettings();
      toggle();
      toast.success(jobPositionToEdit ? t('alerts.success_update') : t('alerts.success_create'));
    } else {
      toast.error(data?.message || t('alerts.error'));
      toggle();
    }
    setSaveLoading(false);
  }

  return(
    <Modal
      isOpen={isOpen}
      toggle={toggle}
      centered
    >
      <ModalHeader toggle={toggle}>
        {jobPositionToEdit ? t('hr.settings.jobPositions.edit') : t('hr.settings.jobPositions.create_new')}
      </ModalHeader>

      <ModalBody>
        <FormGroup>
          <Label>{t('common.name')}: </Label>
          <Input 
            value={sourceData?.name}
            onChange={e => setSourceData({...sourceData, name: e.target.value})}
          />
        </FormGroup>
      </ModalBody>

      <ModalFooter>
        <DefaultButton color="secondary" size="sm" outline onClick={toggle}>{t('common.cancel')}</DefaultButton>
        <DefaultButton 
          color="primary" 
          size="sm" 
          onClick={saveJobPosition}
          loading={saveLoading}
          disabled={saveLoading || !sourceData?.name}
        >{t('common.save')}</DefaultButton>
      </ModalFooter>
    </Modal>
  );
}

export default CreateJobPositionModal;